<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Service Account</span>
        </v-card-title>
        <v-card-text>
          Do you want to delete this service account :
          <strong>"{{ serviceAccount ? serviceAccount.application_name : "" }}"</strong>
          ({{serviceAccount ? serviceAccount.application_id : ""}}) ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">Close</v-btn>
          <v-btn color="error" text @click="deleteServiceAccount">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="error" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    dialog: { type: Boolean, required: true },
    serviceAccount: { type: Object, required: true }
  },
  computed: {
    ...mapState({
      isLoading: state => state.serviceAccounts.deleteOne.pending
    })
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    deleteServiceAccount() {
      this.$emit("deleteServiceAccount", this.serviceAccount.uuid);
    }
  }
};
</script>